module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAjklEQVQ4jWNgGJ7AeOf/VUY7/tsSo5YJm+B/JoZ6RgaGuSbb/3uR7QqD7f8VjHf8v2qy/X8E2YaYbv0vYbzj/3mT7f/TcalhJGSI7pb/gqwsDFsYGRk2n3Vn7ECXxxoGWMF/hv9Eq4UBYryAE0AD8ZrRzv/hJGs22v1f03jH/1smO/97kqyZgYG0hDQMAAD+Hjf+Mjfx9wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/images/bred_arrow.png
// module id = ../../../../../src/assets/images/bred_arrow.png
// module chunks = 2